'use client';

import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from './cn';
import { TitleSmall } from './typography';
import { XIcon } from './XIcon';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

interface PopoverContentProps extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  title?: string;
  onClose?: () => void;
  immersive?: boolean;
  children: React.ReactNode;
}

const PopoverContent = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, PopoverContentProps>(
  ({ className, align = 'end', sideOffset = 4, title, onClose, immersive, children, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <>
        {immersive && <div className="fixed inset-0 z-40 bg-white opacity-50" />}
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 min-h-[381px] max-w-[400px] min-w-[381px] origin-(--radix-popover-content-transform-origin) overflow-y-auto rounded-2xl border-2 border-black bg-white px-5 py-4 shadow-black',
            className
          )}
          {...props}
        >
          {title && onClose && (
            <div className="flex w-full border-b border-black pb-4">
              <TitleSmall>{title}</TitleSmall>
              <button onClick={onClose} className="ml-auto">
                <XIcon className="size-5" />
              </button>
            </div>
          )}
          {children}
        </PopoverPrimitive.Content>
      </>
    </PopoverPrimitive.Portal>
  )
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
